/**
 * some constants for validation in minichecks
 */

export class MinicheckContants {
  //some min and max values for validation
  static readonly ROOM_SIZE_MIN = 1;
  static readonly ROOM_SIZE_MAX = 500;
  static readonly ELECTRICITY_CONSUMPTION_MIN = 1;
  static readonly ELECTRICITY_CONSUMPTION_MAX = 10000;
  static readonly DISTANCE_KM_MIN = 1;
  static readonly DISTANCE_KM_MAX = 200;
  static readonly DISTANCE_KM_MAX_PUBLIC = 1000;
  static readonly TOURS_MAX_PUBLIC = 50;
  static readonly NUMBER_OF_PEOPLE_MIN = 1;
  static readonly NUMBER_OF_PEOPLE_MAX = 15;
  static readonly NUMBER_OF_MIGRATORS_MIN = 1;
  static readonly NUMBER_OF_MIGRATORS_MAX = 10;
  static readonly NUMBER_OF_DRYING_MIN = 1;
  static readonly NUMBER_OF_DRYING_MAX = 100;
  static readonly NUMBER_OF_CLOTH_WASHING_MIN = 1;
  static readonly NUMBER_OF_CLOTH_WASHING_MAX = 100;
  static readonly NUMBER_OF_BATHS_MIN = 1;
  static readonly NUMBER_OF_BATHS_MAX = 100;
  static readonly NUMBER_OF_SHOWERS_MIN = 1;
  static readonly NUMBER_OF_SHOWERS_MAX = 100;
  static readonly MICROWAVE_HEATING_MIN = 1;
  static readonly MICROWAVE_HEATING_MAX = 100;
  static readonly WEEKLY_DEFROST_MIN = 1;
  static readonly WEEKLY_DEFROST_MAX = 100;
  static readonly LIVING_AREA_MIN = 1;
  static readonly LIVING_AREA_MAX = 500;
  static readonly HOUSING_SUFFICIENCY_LIVING_AREA_MIN = 20;
  static readonly HOUSING_SUFFICIENCY_LIVING_AREA_MAX = 200;
  static readonly HOUSING_SUFFICIENCY_LIVING_AREA_AVERAGE = 110;
  static readonly NUMBER_OF_ROOMS_MIN = 1;
  static readonly NUMBER_OF_ROOMS_MAX = 20;
  static readonly NUMBER_HAND_WASH_MIN = 1;
  static readonly NUMBER_HAND_WASH_MAX = 500;
  static readonly DO_PER_WEEK_MIN = 1;
  static readonly DO_PER_WEEK_MAX = 100;
  static readonly DAILY_HEATED_WATER_MIN = 1;
  static readonly DAILY_HEATED_WATER_MAX = 100;
  static readonly USAGE_PER_MONTH_MIN = 1;
  static readonly USAGE_PER_MONTH_MAX = 100;

  //repeating options in different minicheck actions
  static readonly ENERGY_SOURCE_OPTIONS = ['gas', 'oil', 'electricity', 'district_heating', 'unknown'];
  static readonly ENERGY_SOURCE_OPTIONS_BUILDING = ['gas', 'oil', 'district_heating', 'pellets', 'heat_pump'];
  static readonly BUILDING_YEAR_OPTIONS = ['below_1978', '1978-1983', '1984-1993', '1994-2001', 'after_2001'];
  static readonly PERCENT_OPTIONS = ['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];
  static readonly NUTRITION_STYLE_OPTIONS = ['mixed', 'vegi_oneday', 'vegi_50_percent', 'vegi_100_percent', 'vegan'];
  static readonly NUMBER_OF_MIGRATORS = ['1', '2', '3', '4', '5'];
  static readonly FRIDGE_ENERGY_CLASS_OPTIONS = ['a++', 'a+', 'older'];
  static readonly FRIDGE_TYPE_OPTIONS = ['fridge_without-freeze', 'fridge_top-freezer', 'fridge_side-by-side'];
  static readonly BUILDING_TYPE_OPTIONS = ['efh', 'zfh', 'mfh'];
  static readonly BUILDING_LOCATION_OPTIONS = ['frei', 'mitte', 'ecke', 'dhh'];
  static readonly ROOF_TYPE_OPTIONS = ['ausgebaut', 'nicht_ausgebaut', 'flachdach'];
  static readonly INSULATION_MEASURE_OPTIONS = ['kellerdecke', 'geschossdecke', 'dach', 'fassade'];
}
